import { render, staticRenderFns } from "./lottolog.vue?vue&type=template&id=a6ae9fa6&scoped=true&"
import script from "./lottolog.vue?vue&type=script&lang=js&"
export * from "./lottolog.vue?vue&type=script&lang=js&"
import style0 from "./lottolog.vue?vue&type=style&index=0&id=a6ae9fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ae9fa6",
  null
  
)

export default component.exports